import type { FinEnvironmentName, IFinEnvironment } from './environment-types';

export const environment: IFinEnvironment = {
  name: 'qnb' as FinEnvironmentName,
  production: true,
  isSaaSProject: true,
  api: {
    gatewayWSUrl: 'wss://gateway.services.qnb.finverity.com/graphql',
    gatewayUrl: 'https://gateway.services.qnb.finverity.com/graphql',
    SSOUrl: 'https://sso.services.qnb.finverity.com',
    currenciesUrl: 'https://gateway.services.qnb.finverity.com/utils/currency-config',
    userDocumentsUrl: 'https://sso.services.qnb.finverity.com/document-signs',
    fileServerUrl: 'https://fileuploader.services.qnb.finverity.com/files',
    instrumentsUploadTemplateUrl:
      'https://qnb-public-assets.s3.eu-west-2.amazonaws.com/xslx-templates/bulk_instrument_upload.xlsx',
    customersBulkUploadTemplateUrl:
      'https://qnb-public-assets.s3.eu-west-2.amazonaws.com/xslx-templates/bulk_customer_upload_template.xlsx',
    leadsBulkUploadTemplateUrl:
      'https://qnb-public-assets.s3.eu-west-2.amazonaws.com/xslx-templates/self_onboarding_upload_template.xlsx',
    uploadingLeadsForSelfOnboardingTemplateUrl:
      'https://qnb-public-assets.s3.eu-west-2.amazonaws.com/xslx-templates/self_onboarding_upload_template.xlsx',
    bankHolidaysUploadTemplateUrl:
      'https://qnb-public-assets.s3.eu-west-2.amazonaws.com/xslx-templates/bulk_bank_holidays_upload_template.xlsx',
    integrationDocumentationUrl: 'https://gateway.services.qnb.finverity.com/v1/api/integration-docs',
    fullAPIReferenceUrl: 'https://gateway.services.qnb.finverity.com/v1/api/docs',
    rateLimiterHeader: '',
    maxUserInactivityMinutes: 60,
  },
  platform: {
    title: 'QNB Platform',
    company: 'QNB',
    displayUrl: 'qnb.finverity.com',
    companyAddress: 'Building 4, Street 800, Zone 03, Sikkat Alwadi Street, Mshereib Downtown, Doha, Qatar.',
    logo: {
      default: { src: 'assets/logo/logo.svg', width: 135, height: 44 },
      login: { src: 'assets/logo/logo-login.svg', width: 215, height: 72 },
      collapsedSidebar: { src: 'assets/logo/logo-sidebar-collapsed.svg', width: 44, height: 40 },
    },
    faviconUrl: 'assets/favicon/favicon.ico',
    email: 'support@qnb.finverity.com',
    helpLink: 'https://support.finverity.com/kb/guide/en/landing-page-Z0IncfcZbi/Steps/3514119',
    isSsoAuthEnabled: true,
    locale: 'en-GB',
    azureIntegrationPdfUrl: 'https://qnb-public-assets.s3.amazonaws.com/Finverity%20-%20Azure%20integration.pdf',
    showHandEmojiInDashboard: true,
  },
  sentry: {
    enabled: true,
    dsn: 'https://aea0ee4f0b1b49f6b18d5d15aeda5420@o4504480764723200.ingest.sentry.io/4504519285538816',
  },
  firebase: {
    appName: 'FINVERITY',
    apiKey: 'AIzaSyAP2IlVBE8E3ItzeX6e9FkH0GH2mT9GClc',
    authDomain: 'finverity-staging.firebaseapp.com',
    databaseURL: 'https://finverity-staging.firebaseio.com',
    projectId: 'finverity-staging',
    storageBucket: 'finverity-staging.appspot.com',
    messagingSenderId: '1037880577124',
    appId: '1:1037880577124:web:3dd9469e015bef2ffe2371',
    measurementId: 'G-M90YF15270',
  },
  stonly: {
    enabled: true,
    widgetId: '848e9ac1-cbfc-11ee-bc11-06cb0cb2a85e',
  },
  userSnap: {
    enabled: true,
    GlobalAPIKey: '8d1ac1d2-2145-492b-9ad8-62f358f85d2d',
    ProjectAPIKey: 'c05d893e-8ef2-4a17-8dd5-f1b483d4c6f5',
  },
};
